import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyRouteSummaryWithGainAndLossReport } from './Pages';

export const DailyRouteSummaryWithGainAndLossRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyRouteSummaryWithGainAndLossReport} />
    </Fragment>
)